<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet class="dialog" rounded>
            <div class="dialog-header">{{ $t("sites.new_code_model") }}</div>
            <div class="dialog-content">
                <v-form ref="form_new_driver">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="code"
                                :label="$t('sites.models_codes')"
                                counter
                                dense
                                hide-details="auto"
                                light
                                outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
            <div class="dialog-footer d-flex">
                <v-btn elevation="0" @click="showDialog = false">
                    {{ $t("global.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" elevation="0" @click="emitModel">
                    {{ $t("global.validate") }}
                </v-btn
                >
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>
export default {
    name: "NewCodeModel",
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            code: null,
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        emitModel() {
            this.$emit('modelCreated', {code: this.code})
            this.code = null
            this.showDialog = false
        }
    }
};
</script>
